'use client';
import { useMemo } from 'react';

export function StructuredData({ data }: { data: unknown }) {
  const content = useMemo(
    () => ({
      __html: JSON.stringify(data),
    }),
    [data]
  );

  return <script type="application/ld+json" dangerouslySetInnerHTML={content} />;
}
